<template>
	<div class="order-body">
		<Search :ids="ids" :batchSelectData="batchSelectData" :AuthorityList='AuthorityList' :orderKey='orderKey' :orderBy='orderBy' ref='searchRef' @handleSearch="handleSearch" @modifySuc="modifySuc"/>
		<MainTable
			ref='table'
			:size='size'
			:page='page'
			:tableData='tableData'
			:totalCount='totalCount'
			:AuthorityList='AuthorityList'
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
			@sortSearch="sortSearch"
			@modifySuc="modifySuc"
			@selectIds="selectIdsChange"
			@selectData="selectData"
		/>
	</div>
</template>

<script>
import Search from '@/components/withdrawalReview/Search.vue'
import MainTable from '@/components/withdrawalReview/MainTable.vue'
export default {
	name: 'withdrawalReview',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'11_0004_0001_00': false,
				'11_0004_0002_00': false,
				'11_0004_0003_00': false
			},
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			ids: [],
			staff: '',
			dateValue: [],
			cashOutStatus: 1,
			dateType: 0,
			orderKey: '',
			orderBy: '',
			batchSelectData: [],
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		this.orderKey = ''
		this.orderBy = ''
		this.$fxEventBus.$emit('setMenu', '13-3')
		this.getAuthority('11_0004_0000_00')
		this.openPage()
	},
	methods: {
		selectData (data) {
			this.batchSelectData = data
		},
		selectIdsChange (ids) {
			this.ids = ids
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		openPage () {
			if (window.sessionStorage.getItem('withDrawalSelect') && !this.filterFlag) {
				let data = JSON.parse(window.sessionStorage.getItem('withDrawalSelect'))
				this.staff = data.staff
				this.dateType = data.dateType
				this.dateValue = data.dateValue
				this.cashOutStatus = data.cashOutStatus
			}
			this.findCashoutlist()
		},
		modifySuc () {
			this.$refs.table.clear()
			this.openPage()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findCashoutlist()
		},
		handlePageChange (value) {
			this.page = value
			this.findCashoutlist()
		},
		handleSearch (data) {
			this.$refs.table.clear()
			this.ids = []
			this.staff = data.staff
			this.dateValue = data.dateValue
			this.cashOutStatus = data.cashOutStatus
			this.dateType = data.dateType
			this.page = 1
			if (!this.filterFlag) {
				this.saveSelect()
			}
			this.findCashoutlist()
		},
		saveSelect () {
			let params = {
				dateValue: this.dateValue,
				beginDate: this.dateValue.length > 0 ? this.dateValue[0] : null,
				endDate: this.dateValue.length > 0 ? this.dateValue[1] : null,
				dateType: this.dateType,
				cashOutStatus: this.cashOutStatus,
				staff: this.staff,
				page: this.page,
				size: this.size
			}
			window.sessionStorage.setItem('withDrawalSelect', JSON.stringify(params))
		},
		sortSearch (data) {
			this.orderKey = data.orderKey
			this.orderBy = data.orderBy
			this.findCashoutlist()
		},
		findCashoutlist () {
			this.tableData = []
			let params = {
				page: this.page,
				size: this.size,
				staff: this.staff,
				orderKey: this.orderKey,
				orderBy: this.orderBy,
				cashOutStatus: this.cashOutStatus,
				dateType: this.dateType
				// beginDate: this.dataValue[0],
				// endDate: this.dataValue[1]
			}
			if (this.dateValue.length > 0) {
				params.beginDate = this.dateValue[0]
				params.endDate = this.dateValue[1]
			} else {
				params.beginDate = null
				params.endDate = null
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/cashoutlist`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				res.recordList.forEach(e => {
					switch (e.cashOutStatus) {
					case 1:
						e.cashOutStatusName = '待审核'
						break
					case 2:
						e.cashOutStatusName = '待打款'
						break
					case 3:
						e.cashOutStatusName = '已打款'
						break
					}
					if (!(String(e.cashoutmoney).indexOf('.') !== -1 && String(e.cashoutmoney).split('.')[1].length > 2)) {
						e.cashoutmoney = this.$fxUtils.toFixedSHW(e.cashoutmoney, 2)
					}
					// if (!(String(e.commissionvalue).indexOf('.') !== -1 && String(e.commissionvalue).split('.')[1].length > 2)) {
					// 	e.commissionvalue = this.$fxUtils.toFixedSHW(e.commissionvalue, 2)
					// }
				})
				this.tableData = res.recordList
				this.$nextTick(() => {
					this.$refs.table.initIschoose()
				})
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
